export interface StatItem {
  id: string;
  value: number;
  suffix: string; // e.g., '+', '%'
  label: string;
}

export const statsData: StatItem[] = [
  {
    id: 'years-excellence',
    value: 8,
    suffix: '+',
    label: 'Years of Excellence',
  },
  {
    id: 'products-manufactured',
    value: 5000,
    suffix: '+',
    label: 'Products Manufactured',
  },
  {
    id: 'skilled-workers',
    value: 100,
    suffix: '+',
    label: 'Skilled Workers',
  },
  {
    id: 'countries-exported',
    value: 50,
    suffix: '+',
    label: 'Countries Exported',
  },
  {
    id: 'quality-focus',
    value: 100,
    suffix: '%',
    label: 'Quality Focus',
  },
];